<template>
	<!-- Vue Material Button -->
	<!-- https://vuematerial.io/components/button -->
	<md-button
		:class="{
			'md-accent': secondary,
			'md-dense': dense,
			'md-fab': floating,
			'md-icon-button': (svgIcon || icon || $slots['icon']) && !text,
			'md-primary': primary,
			'md-raised': raised,
			'ui-button--large': large
		}"
		:disabled="disabled"
		:type="type"
		class="ui-button"
		@click="$emit('click', $event)"
		@mouseleave="$emit('mouseleave')"
	>
		<md-icon v-if="icon" :class="icon"/>
		<svg
			v-if="svgIcon"
			width="24"
			height="24"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<slot />
		</svg>
		<slot name="icon"></slot>
		<span>{{ text }}</span>

		<md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
	</md-button>
</template>

<script>
export default {
	name: "Button",
	props: {
		dense: {
			type: Boolean,
			default: false,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		floating: {
			type: Boolean,
			default: false,
			required: false
		},
		icon: {
			type: String,
			default: "",
			required: false
		},
		large: {
			type: Boolean,
			default: false,
			required: false
		},
		primary: {
			type: Boolean,
			default: false,
			required: false
		},
		raised: {
			type: Boolean,
			default: false,
			required: false
		},
		secondary: {
			type: Boolean,
			default: false,
			required: false
		},
		svgIcon: {
			type: Boolean,
			default: false,
			required: false
		},
		text: {
			type: String,
			default: "",
			required: false
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		},
		type: {
			type: String,
			default: "button", // submit, reset, button
			required: false
		}
	}
};
</script>

<style lang="scss" scoped>
.md-button:not(.md-icon-button) {
	min-width: 80px;
}
.ui-button--large {
	font-size: 24px;
	min-height: 56px;
	span {
		vertical-align: middle;
	}
	&:not(.md-icon-button) {
		min-width: 160px;
	}
	&.md-icon-button {
		min-width: 56px;
	}
}
svg {
	position: relative;
	top: 2px;
}
</style>
